angular.module('unica_agenda.agenda_controllers', [])

.controller('AgendaController',
	function(
		$rootScope, $scope, $state, $stateParams,
		AgendaService,
		TASK_TYPES
	) {

	// $scope.taskTypes = TASK_TYPES;
	//
	// $scope.event_id = $stateParams.event_id;
	//
	// $rootScope.getEvent( $stateParams.event_id );
	//
	// $rootScope.getEventStages( $stateParams.event_id );
	//
	// $rootScope.getAgenda( $stateParams.event_id );
	//
	// $rootScope.getRelatorList();
	//
	// $rootScope.getWorkshopSessionByEvent( $stateParams.event_id );
	//
	// $scope.addTask = function() {
	// 	$rootScope.agendaData.push({
	// 		type: '',
	// 		title: '',
	// 		from_date: '',
	// 		to_date: '',
	// 		from_time: '',
	// 		to_time: '',
	// 	});
	// };
	//
	// $scope.removeTask = function(index) {
	// 	$rootScope.agendaData.splice(index, 1);
	// };
	//
	//
	// function parseAgendaFromDateToTimestamp(agendaData) {
	// 	angular.forEach(agendaData, function(task, key) {
	// 		if ( task.type == 'speech' || task.type == 'meal' ) {
	// 			agendaData[key].from_date = moment( task.from_date ).format('YYYY-MM-DD');
	// 			agendaData[key].from_time = moment( task.from_time ).format('HH:mm:ss');
	// 			agendaData[key].to_date   = moment( task.to_date ).format('YYYY-MM-DD');
	// 			agendaData[key].to_time   = moment( task.to_time ).format('HH:mm:ss');
	// 		} else {
	// 			agendaData[key].from_date = null;
	// 			agendaData[key].from_time = null;
	// 			agendaData[key].to_date   = null;
	// 			agendaData[key].to_time   = null;
	// 		}
	// 	});
	// 	return agendaData;
	// };
	//
	//
	// $scope.saveAgenda = function() {
	// 	$scope.showLoader();
	// 	var agData = angular.copy($rootScope.agendaData);
	// 	agData = parseAgendaFromDateToTimestamp(agData);
	//
	// 	AgendaService
	// 		.save(agData, $rootScope.eventData.id)
	// 		.then(function(data) {
	// 			$scope.hideLoader();
	//
	// 			if (!data.error) {
	// 				$scope.showSuccessMsg('Agenda aggiornata con successo!', '');
	// 				$state.go('app.event.comunicate', { id: $rootScope.eventData.id });
	// 			} else {
	// 				$rootScope.manageError(data);
	// 			}
	// 		});
	// };
});
